<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>
        <span class="dialog-title">{{title}}</span>
    </h1>
    <div class="scroll" fxFlex.gt-sm="auto">
        <div class="dialog-message" [innerHTML]="message | safeHTML"></div>
    </div>
    <div
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayoutGap="15px"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="center center"
        fxLayoutGap.lt-md="10px"
        class="margin-top"
    >
        <button mat-raised-button color="primary" class="okbtn" (click)="OKHandler()">{{oktext}}</button>
    </div>
</div>
